var _radialGradient, _path, _defs, _clipPath, _radialGradient2, _path2, _radialGradient3, _path3, _radialGradient4, _path4, _radialGradient5, _path5, _radialGradient6, _path6, _radialGradient7, _path7, _radialGradient8, _path8, _radialGradient9, _path9, _radialGradient10, _path10, _radialGradient11, _path11, _radialGradient12, _path12, _radialGradient13, _path13, _radialGradient14, _path14, _radialGradient15, _path15, _radialGradient16, _path16, _radialGradient17, _path17, _radialGradient18, _path18, _radialGradient19, _path19, _radialGradient20, _path20, _radialGradient21, _path21, _radialGradient22, _path22, _radialGradient23, _path23, _radialGradient24, _path24, _radialGradient25, _path25;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMissingImageRect(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 350 350",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 175,
    cy: 175,
    r: 250.3336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3605,
    stopColor: "#e9e9e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e6e6e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M0 0h350v350H0z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M81.7 152.5v-38.6l-16.8 26.3h-5.7l-16.8-26.3v38.6h-8.2V95.1H40l22.1 35 22.1-35h5.7v57.4h-8.2m16.4 0V95.1h8.2v57.4h-8.2m96.2 0V95.1h8.2v57.4h-8.2m59.1 0L219 110.4v42.1h-8.2V95.1h5.7l34.4 42.2V95.1h8.2v57.4h-5.7m-142.2-8.8l5.7-5.6c4 4.9 8.7 7.4 14 7.4 2.7 0 5.1-.8 7-2.4 2-1.6 3-3.7 3-6.2 0-2.6-1-4.7-3-6.3-2-1.6-4.9-3.1-8.7-4.6-3.8-1.5-6.5-2.8-8.1-3.8-4.9-3.2-7.3-7.4-7.3-12.6 0-4.2 1.6-7.8 5-10.8 3.3-3 7.5-4.5 12.4-4.5 5.7 0 10.8 1.9 15.4 5.7l-4.8 6c-3.1-2.6-6.5-3.9-10.2-3.9-2.6 0-4.8.7-6.7 2.1-1.9 1.4-2.8 3.3-2.8 5.6 0 2.2 1 4 3 5.5s4.9 2.9 8.6 4.4c3.7 1.5 6.3 2.8 8 3.9 5 3.3 7.5 7.7 7.5 13.1 0 5-1.7 9-5.1 12.1-3.4 3.1-7.6 4.6-12.7 4.6-8.2-.1-14.9-3.3-20.2-9.7m39.5 0l5.7-5.6c4 4.9 8.7 7.4 14 7.4 2.7 0 5.1-.8 7-2.4 2-1.6 3-3.7 3-6.2 0-2.6-1-4.7-3-6.3-2-1.6-4.9-3.1-8.7-4.6-3.8-1.5-6.5-2.8-8.1-3.8-4.9-3.2-7.3-7.4-7.3-12.6 0-4.2 1.6-7.8 5-10.8 3.3-3 7.5-4.5 12.4-4.5 5.7 0 10.8 1.9 15.4 5.7l-4.8 6c-3.1-2.6-6.5-3.9-10.3-3.9-2.6 0-4.8.7-6.7 2.1-1.9 1.4-2.8 3.3-2.8 5.6 0 2.2 1 4 3 5.5s4.9 2.9 8.6 4.4c3.7 1.5 6.3 2.8 8 3.9 5 3.3 7.5 7.7 7.5 13.1 0 5-1.7 9-5.1 12.1-3.4 3.1-7.6 4.6-12.7 4.6-8.1-.1-14.8-3.3-20.1-9.7m123.8 1.2c-5.6-5.6-8.4-12.6-8.4-21.1 0-8.3 2.8-15.3 8.3-21 5.5-5.7 12.5-8.5 20.7-8.5 4.1 0 8 .8 11.7 2.3 3.7 1.6 6.8 3.7 9.3 6.5l-5.5 5.4c-1.7-1.9-4-3.5-6.8-4.7-2.8-1.2-5.7-1.8-8.7-1.8-5.9 0-10.8 2.1-14.8 6.2-4 4.2-6 9.3-6 15.5 0 6.4 2 11.6 6.2 15.7 4.1 4 9.2 6.1 15.4 6.1 5.8 0 10.5-1.8 14.1-5.3v-14.8h-16.4v-7.8h24.6v25c-2.5 3.2-5.8 5.8-9.8 7.7-4 2-8.2 2.9-12.5 2.9-8.6.1-15.8-2.7-21.4-8.3M64.4 243.2v-57.4h8.2v57.4h-8.2m64 0v-38.6l-16.8 26.3h-5.7L89 204.6v38.6h-8.2v-57.4h5.7l22.1 35 22.1-35h5.7v57.4h-8m28.8-22.6h17.7l-8.9-21.3-8.8 21.3m27 22.6l-6.1-14.8h-24.2l-6 14.8h-8.5l23.8-57.4h5.8l23.8 57.4h-8.6m65.5 0v-57.4h32.8v7.8h-24.6v14.8h18.9v7.8h-18.9v19.3h25.4v7.8h-33.6m-51.4-7.7c-5.6-5.6-8.4-12.6-8.4-21.1 0-8.3 2.8-15.3 8.3-21 5.5-5.7 12.5-8.5 20.7-8.5 4.1 0 8 .8 11.7 2.3 3.7 1.6 6.8 3.7 9.3 6.5l-5.5 5.4c-1.8-1.9-4-3.5-6.8-4.7-2.8-1.2-5.7-1.8-8.7-1.8-5.9 0-10.8 2.1-14.8 6.2-4 4.2-6 9.3-6 15.5 0 6.4 2 11.6 6.2 15.7 4.1 4 9.2 6.1 15.4 6.1 5.8 0 10.5-1.8 14.1-5.3v-14.8h-16.4v-7.8H242v25c-2.5 3.2-5.8 5.8-9.8 7.7-4 2-8.2 2.9-12.5 2.9-8.7.1-15.8-2.7-21.4-8.3"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("use", {
    overflow: "visible",
    xlinkHref: "#b"
  }))), _radialGradient2 || (_radialGradient2 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M316.5 144.5c-2.2 2.3-5 4.3-8.2 5.8-1.8.9-3.7 1.6-5.6 2.1 1.9-.5 3.8-1.2 5.6-2.1 3.2-1.5 6-3.5 8.2-5.8m-48.6-9.9c1.4 3.8 3.6 7.2 6.6 10.2 2.3 2.3 4.8 4 7.5 5.4-2.7-1.3-5.2-3.1-7.5-5.4-3-2.9-5.2-6.3-6.6-10.2m42.1-9.2v14.8c-.9.9-1.8 1.6-2.8 2.3 1-.7 1.9-1.4 2.8-2.3v-14.8m6.1-22.3l-2.1 2.1 2.1-2.1m-15.5-.4c1.1.3 2.2.7 3.2 1.1 2.8 1.2 5.1 2.8 6.8 4.7-1.8-1.9-4-3.5-6.8-4.7-1.1-.4-2.1-.8-3.2-1.1m-17-6.3c-3.4 1.4-6.4 3.5-9.2 6.3-1 1.1-2 2.1-2.8 3.3.8-1.1 1.8-2.2 2.8-3.3 2.7-2.7 5.8-4.8 9.2-6.3",
    clipPath: "url(#d)"
  })), _radialGradient3 || (_radialGradient3 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M295.1 94.2c-4.2 0-8 .7-11.5 2.2-3.4 1.4-6.4 3.5-9.2 6.3-1 1.1-2 2.2-2.8 3.3-3.7 5-5.5 10.9-5.5 17.7 0 3.9.6 7.6 1.8 10.9 1.4 3.8 3.6 7.2 6.6 10.2 2.3 2.3 4.8 4.1 7.5 5.4 4.1 2 8.7 3 13.8 3 2.3 0 4.6-.3 6.9-.9 1.9-.5 3.8-1.2 5.6-2.1 3.2-1.6 5.9-3.5 8.2-5.8.6-.6 1.1-1.2 1.6-1.9v-25h-24.6v7.8h16.4v14.8c-.9.9-1.8 1.6-2.8 2.3-3.1 2-6.9 3.1-11.3 3.1-6.2 0-11.3-2-15.4-6.1-4.1-4-6.2-9.3-6.2-15.7 0-6.2 2-11.3 6-15.5 4-4.2 8.9-6.2 14.8-6.2 1.9 0 3.7.2 5.5.7 1.1.3 2.2.7 3.2 1.1 2.8 1.2 5.1 2.8 6.8 4.7l3.4-3.3 2.1-2.1c-2.5-2.8-5.6-5-9.3-6.5-3.6-1.6-7.5-2.4-11.6-2.4",
    clipPath: "url(#d)"
  })), _radialGradient4 || (_radialGradient4 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "f",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M153.8 140.6l-3.1 3.1c2.7 3.3 5.9 5.8 9.4 7.4-3.5-1.6-6.6-4.1-9.4-7.4l3.1-3.1m2.6-2.5c.2.2.4.4.5.6-.2-.1-.3-.4-.5-.6m12.3-20.5c1.3.7 2.8 1.3 4.5 2 3.7 1.5 6.4 2.8 8 3.9.6.4 1.1.8 1.7 1.2-.5-.4-1.1-.8-1.7-1.2-1.6-1.1-4.3-2.4-8-3.9-1.7-.7-3.2-1.3-4.5-2m13.6-20.3c1.3.8 2.6 1.7 3.9 2.7l-1.9 2.4 1.9-2.4c-1.3-1.1-2.6-2-3.9-2.7m-20.6-1c-1.2.6-2.3 1.4-3.4 2.4-3.3 3-5 6.6-5 10.8 0 5.2 2.4 9.4 7.3 12.6 1.6 1 4.3 2.3 8.1 3.8s6.7 3 8.7 4.6c2 1.6 3 3.7 3 6.3 0 2.5-1 4.6-3 6.2-.5.4-1.1.8-1.7 1.1.6-.3 1.2-.7 1.7-1.1 2-1.6 3-3.7 3-6.2 0-2.6-1-4.7-3-6.3-2-1.6-4.9-3.1-8.7-4.6-3.8-1.5-6.5-2.8-8.1-3.8-4.9-3.2-7.3-7.4-7.3-12.6 0-4.2 1.7-7.8 5-10.8 1-.9 2.2-1.7 3.4-2.4",
    clipPath: "url(#d)"
  })), _radialGradient5 || (_radialGradient5 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "g",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M170.7 94.2c-3.4 0-6.4.7-9 2.1-1.2.6-2.3 1.4-3.4 2.4-3.3 3-5 6.6-5 10.8 0 5.2 2.4 9.4 7.3 12.6 1.6 1 4.3 2.3 8.1 3.8s6.7 3 8.7 4.6c2 1.6 3 3.7 3 6.3 0 2.5-1 4.6-3 6.2-.5.4-1.1.8-1.7 1.1-1.6.9-3.4 1.3-5.3 1.3-5.1 0-9.6-2.2-13.5-6.7-.2-.2-.4-.4-.5-.6l-2.5 2.5-3.1 3.1c2.7 3.3 5.9 5.8 9.4 7.4 3.2 1.5 6.8 2.2 10.7 2.2 5.1 0 9.3-1.5 12.7-4.6 3.4-3.1 5.1-7.1 5.1-12.1 0-4.8-1.9-8.8-5.8-11.9-.5-.4-1.1-.8-1.7-1.2-1.6-1.1-4.3-2.4-8-3.9-1.7-.7-3.2-1.3-4.5-2-1.6-.8-3-1.6-4.1-2.4-2-1.4-3-3.3-3-5.5 0-2.3.9-4.2 2.8-5.6 1.9-1.4 4.1-2.1 6.7-2.1 3.7 0 7.1 1.3 10.3 3.9l2.9-3.6 1.9-2.4c-1.2-1-2.5-1.9-3.9-2.7-3.6-1.9-7.4-3-11.6-3",
    clipPath: "url(#d)"
  })), _radialGradient6 || (_radialGradient6 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "h",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M111.4 144c2.6 3.1 5.5 5.3 8.7 6.9-3.2-1.6-6.1-3.9-8.7-6.9m2.8-3.3l-3 3 3-3m2.7-2.6c.2.2.3.4.5.6-.2-.2-.4-.4-.5-.6m12.2-20.5c1.3.7 2.9 1.4 4.5 2 3.7 1.5 6.4 2.8 8 3.9.8.5 1.5 1 2.1 1.6-.6-.6-1.4-1.1-2.1-1.6-1.6-1.1-4.3-2.4-8-3.9-1.7-.7-3.2-1.4-4.5-2m13.6-20.4c1.4.8 2.7 1.7 3.9 2.7l-1.8 2.2 1.8-2.2c-1.3-1-2.6-1.9-3.9-2.7m-20.4-1c-1.3.7-2.5 1.5-3.6 2.5-3.3 3-5 6.6-5 10.8 0 5.2 2.4 9.4 7.3 12.6 1.6 1 4.3 2.3 8.1 3.8s6.7 3 8.7 4.6c2 1.6 3 3.7 3 6.3 0 2.5-1 4.6-3 6.2-.6.5-1.2.9-1.8 1.2.6-.3 1.2-.7 1.8-1.2 2-1.6 3-3.7 3-6.2 0-2.6-1-4.7-3-6.3-2-1.6-4.9-3.1-8.7-4.6-3.8-1.5-6.5-2.8-8.1-3.8-4.9-3.2-7.3-7.4-7.3-12.6 0-4.2 1.7-7.8 5-10.8 1.2-1 2.3-1.8 3.6-2.5",
    clipPath: "url(#d)"
  })), _radialGradient7 || (_radialGradient7 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "i",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M131.2 94.2c-3.3 0-6.3.7-8.9 2-1.3.7-2.5 1.5-3.5 2.5-3.3 3-5 6.6-5 10.8 0 5.2 2.4 9.4 7.3 12.6 1.6 1 4.3 2.3 8.1 3.8s6.7 3 8.7 4.6c2 1.6 3 3.7 3 6.3 0 2.5-1 4.6-3 6.2-.6.5-1.2.9-1.8 1.2-1.6.8-3.3 1.2-5.3 1.2-5.1 0-9.6-2.3-13.5-6.8-.2-.2-.3-.4-.5-.6l-2.6 2.6-3 3 .3.3c2.6 3 5.5 5.3 8.7 6.9 3.3 1.6 7 2.4 11.1 2.4 5.1 0 9.3-1.5 12.7-4.6 3.4-3.1 5.1-7.1 5.1-12.1 0-4.6-1.8-8.5-5.3-11.5-.6-.6-1.4-1.1-2.1-1.6-1.6-1.1-4.3-2.4-8-3.9-1.7-.7-3.2-1.4-4.5-2-1.6-.8-2.9-1.6-4-2.4-2-1.4-3-3.3-3-5.5 0-2.3.9-4.2 2.8-5.6 1.9-1.4 4.1-2.1 6.7-2.1 3.7 0 7.1 1.3 10.2 3.9l3.1-3.8 1.8-2.2c-1.3-1.1-2.6-2-3.9-2.7-3.8-1.9-7.6-2.9-11.7-2.9",
    clipPath: "url(#d)"
  })), _radialGradient8 || (_radialGradient8 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "j",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#j)",
    d: "M218.9 110.3l34.4 42.1-34.4-42.1m-2.4-15.2h-5.7v57.4-57.4h5.7l34.4 42.2-34.4-42.2m42.6 0h-8.2 8.2v57.4-57.4",
    clipPath: "url(#d)"
  })), _radialGradient9 || (_radialGradient9 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "k",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#k)",
    d: "M259.1 95.1h-8.2v42.1l-34.4-42.1h-5.8v57.4h8.2v-42.2l34.5 42.2h5.7V95.1",
    clipPath: "url(#d)"
  })), _radialGradient10 || (_radialGradient10 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "l",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#l)",
    d: "M202.5 95.1h-8.2v57.4-57.4h8.2",
    clipPath: "url(#d)"
  })), _radialGradient11 || (_radialGradient11 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "m",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#m)",
    d: "M202.5 95.1h-8.2v57.4h8.2V95.1",
    clipPath: "url(#d)"
  })), _radialGradient12 || (_radialGradient12 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "n",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#n)",
    d: "M106.3 95.1h-8.2v57.4-57.4h8.2",
    clipPath: "url(#d)"
  })), _radialGradient13 || (_radialGradient13 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "o",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#o)",
    d: "M106.3 95.1h-8.2v57.4h8.2V95.1",
    clipPath: "url(#d)"
  })), _radialGradient14 || (_radialGradient14 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "p",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#p)",
    d: "M43.3 115.3l15.9 24.8h5.7-5.7l-15.9-24.8m38.4-1.5v38.6-38.6M39.9 95.1h-5.8v57.4-57.4h5.8l22.1 35-22.1-35m50 0h-5.7 5.7v57.4-57.4",
    clipPath: "url(#d)"
  })), _radialGradient15 || (_radialGradient15 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "q",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#q)",
    d: "M89.9 95.1h-5.8l-22.1 35-22.2-35h-5.7v57.4h8.2v-38.7l1 1.5 15.8 24.9h5.8l16.8-26.4v38.7h8.2V95.1",
    clipPath: "url(#d)"
  })), _radialGradient16 || (_radialGradient16 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "r",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#r)",
    d: "M216 236c1.2.2 2.3.2 3.6.2 1 0 1.9 0 2.8-.1-.9.1-1.8.1-2.8.1-1.2 0-2.4-.1-3.6-.2m24.2-.7c-2.2 2.3-4.9 4.2-8.1 5.8-1.6.8-3.2 1.4-4.9 1.9 1.7-.5 3.3-1.1 4.9-1.9 3.2-1.6 5.9-3.5 8.1-5.8m-48.5-10c1.4 3.9 3.6 7.3 6.6 10.3 2.4 2.4 5 4.2 8 5.6-2.9-1.4-5.6-3.2-8-5.6-3-3-5.2-6.5-6.6-10.3m42-9.2v14.8c-1.1 1.1-2.2 2-3.5 2.7 1.3-.7 2.4-1.6 3.5-2.7v-14.8m6.2-22.3l-1.5 1.5 1.5-1.5m-15.5-.3c1.1.3 2.1.6 3.1 1.1 2.8 1.2 5.1 2.8 6.8 4.7-1.8-1.9-4-3.5-6.8-4.7-1-.5-2-.8-3.1-1.1m-15.1-7.1c-4.2 1.4-7.9 3.7-11.2 7.1-1.4 1.4-2.6 2.9-3.6 4.5 1-1.6 2.3-3.1 3.6-4.5 3.3-3.3 7.1-5.7 11.2-7.1",
    clipPath: "url(#d)"
  })), _radialGradient17 || (_radialGradient17 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "s",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#s)",
    d: "M218.9 185c-3.4 0-6.6.5-9.6 1.5-4.2 1.4-7.9 3.7-11.1 7.1-1.4 1.4-2.6 2.9-3.6 4.5-3.1 4.8-4.7 10.3-4.7 16.5 0 3.9.6 7.5 1.8 10.8 1.4 3.9 3.6 7.3 6.7 10.3 2.4 2.4 5 4.3 8 5.6 4 1.9 8.4 2.8 13.4 2.8 2.6 0 5.1-.3 7.6-1.1 1.7-.5 3.3-1.1 4.9-1.9 3.2-1.5 5.8-3.5 8.1-5.8.6-.6 1.2-1.3 1.7-2v-25h-24.6v7.8h16.4v14.8c-1.1 1.1-2.2 2-3.5 2.7-2.3 1.3-4.9 2.2-7.8 2.5-.9.1-1.8.1-2.8.1-1.2 0-2.4-.1-3.6-.2-4.6-.6-8.6-2.6-11.8-5.8-4.1-4-6.2-9.3-6.2-15.7 0-6.2 2-11.3 6-15.5 4-4.2 8.9-6.2 14.8-6.2 1.9 0 3.7.2 5.6.7 1.1.3 2.1.6 3.1 1.1 2.8 1.2 5.1 2.8 6.8 4.7l4-3.9 1.5-1.5c-2.5-2.8-5.6-5-9.3-6.5-3.8-1.7-7.7-2.4-11.8-2.4",
    clipPath: "url(#d)"
  })), _radialGradient18 || (_radialGradient18 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "t",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#t)",
    d: "M283.3 235.4h-25.4 25.4m-.8-49.6h-32.8v57.4-57.4h32.8v7.8h-24.6 24.6v-7.8",
    clipPath: "url(#d)"
  })), _radialGradient19 || (_radialGradient19 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "u",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#u)",
    d: "M282.5 185.8h-32.8v57.4h33.6v-7.8h-25.4v-19.3h18.9v-7.8h-18.9v-14.7h24.6v-7.8",
    clipPath: "url(#d)"
  })), _radialGradient20 || (_radialGradient20 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "v",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#v)",
    d: "M178.1 228.4l1.2 2.9-1.2-2.9m-15.9-19.6l-4.9 11.9 4.9-11.9m6.8-23h-5.8l-23.8 57.4 23.8-57.4h5.8l14 33.8-14-33.8",
    clipPath: "url(#d)"
  })), _radialGradient21 || (_radialGradient21 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "w",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#w)",
    d: "M162.2 208.8l3.9-9.5 8.9 21.3h-17.7l4.9-11.8m6.8-23h-5.7l-23.8 57.4h8.5l6-14.8h24.2l1.2 2.9 4.9 11.9h8.5l-9.8-23.6-14-33.8",
    clipPath: "url(#d)"
  })), _radialGradient22 || (_radialGradient22 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "x",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#x)",
    d: "M89 204.6l16.8 26.3h5.7-5.7L89 204.6m39.4 0v38.6-38.6m-41.8-18.8h-5.7v57.4-57.4h5.7l22.1 35-22.1-35m50 0h-5.7 5.7v57.4-57.4",
    clipPath: "url(#d)"
  })), _radialGradient23 || (_radialGradient23 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "y",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#y)",
    d: "M136.6 185.8h-5.8l-22.1 35-22.2-35h-5.7v57.4H89v-38.6l16.8 26.3h5.8l16.8-26.3v38.6h8.2v-57.4",
    clipPath: "url(#d)"
  })), _radialGradient24 || (_radialGradient24 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "z",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ebf0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0e6f1"
  }))), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#z)",
    d: "M72.6 185.8h-8.2v57.4-57.4h8.2",
    clipPath: "url(#d)"
  })), _radialGradient25 || (_radialGradient25 = /*#__PURE__*/React.createElement("radialGradient", {
    id: "A",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(251.0268 0 0 -251.0268 175 175)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e1d7e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e1cde3"
  }))), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#A)",
    d: "M72.6 185.8h-8.2v57.4h8.2v-57.4",
    clipPath: "url(#d)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMissingImageRect);
export default __webpack_public_path__ + "static/media/MissingImageRect.e2c94da4400110356ef256f100d6adff.svg";
export { ForwardRef as ReactComponent };